import React from 'react';
import { useSelector } from 'react-redux';
import styles from './RMDEnabled.module.scss';
import RMDTransactions from '../RMDTransactions/RMDTransactions';
import { getAllSystematics } from '../../../redux/modules/existingAutomatics/existingAutomatics.selectors';

const RMDEnabled = ({ rmdInfo }) => {
  const { autoSell, autoExchange } = useSelector(getAllSystematics);
  return (
    <div className={styles['container']}>
      <div className={styles['body']}>
        <RMDTransactions
          autoSellSystematic={autoSell}
          autoExchangeSystematic={autoExchange}
          rmdInfo={rmdInfo}
        />
      </div>
    </div>
  );
};

export default RMDEnabled;
